module.exports = __webpack_public_path__ + "img/icon-tolerance.637e6027.png";